import {
  get, patch, post, del,
} from './helper';

export async function checkTokenExpired(token) {
  const res = await post({
    url: 'email/check_expired',
    data: {
      confirmation_token: token,
    },
  });
  return res?.data || res;
}

export async function chooseTeam(identification) {
  const res = await post({
    url: 'user/choose_team',
    data: { identification },
  });
  return res?.data || res;
}

export async function getDepartments() {
  const res = await get({
    url: 'team/departments',
  });
  return res?.data || res;
}

export async function getTeams() {
  const res = await post({
    url: '/user/show_teams',
  });
  return res?.data || res;
}

export async function getUser() {
  const res = await get({
    url: 'users/me',
    version: 2,
  });
  return res?.data || res;
}

export async function login(data) {
  const res = await post({
    url: 'user/sign_in_v2',
    data,
  });
  return res?.data || res;
}

export async function resendVerifyEmail(email) {
  const res = await post({
    url: 'email/resend_invite',
    data: { email },
  });
  return res?.data || res;
}

export async function sendForgetPasswordLink(data) {
  const res = await post({
    url: 'user/reset_password',
    data,
  });
  return res?.data || res;
}

export async function setPassword(data) {
  const res = await post({
    url: 'email/user_set_password',
    data,
  });
  return res?.data || res;
}

export async function updateUser(data) {
  const res = await patch({
    url: 'member',
    data,
  });
  return res?.data || res;
}

export async function registerLineNotify(data) {
  const res = await post({
    url: 'users/line_notify',
    data,
    version: 2,
  });
  return res?.data || res;
}

export async function unregisterLineNotify(data) {
  const res = await del({
    url: 'users/line_notify',
    data,
    version: 2,
  });
  return res?.data || res;
}

export default {
  checkTokenExpired,
  chooseTeam,
  getDepartments,
  getTeams,
  getUser,
  login,
  resendVerifyEmail,
  sendForgetPasswordLink,
  setPassword,
  updateUser,
  registerLineNotify,
  unregisterLineNotify,
};
